import React, { useState, useEffect } from "react";
import { Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import SplashScreen from "./Components/SplashScreen/SplashScreen";
import "./App.css";

const StartPage = React.lazy(() => import("./Components/StartPage/StartPage"));
const Login = React.lazy(() => import("./Components/Login/Login"));
const Otp = React.lazy(() => import("./Components/Otp/Otp"));
const Upload = React.lazy(() => import("./Components/Upload/Upload"));
const Success = React.lazy(() => import("./Components/Success/Success"));
const Now = React.lazy(() => import("./Components/Now/Now"));
const Face = React.lazy(() => import("./Components/Face/Face"));
const Web = React.lazy(() => import("./Components/Web/Web"));
const QR = React.lazy(() => import("./Components/QR/QR"));
const Invite = React.lazy(() => import("./Components/Invite/Invite"));
const VerifyEmail = React.lazy(() =>
  import("./Components/VerifyEmail/VerifyEmail")
);

// Pre-Consultation Survey
const RedirectToNotion = () => {
  useEffect(() => {
    window.location.href =
      "https://desert-olivine-d7e.notion.site/1923cb3b322380b587bfc655e5049d08";
  }, []);

  return null;
};

// The Treatment Claim Coupon Page
const TreatmentClaimCoupon = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          backgroundColor: "#161616",
          fontFamily: "'Montserrat', sans-serif",
          textAlign: "center",
          maxWidth: "600px",
          padding: "40px",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
        }}
      >
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            marginBottom: "2rem",
            color: "#CDAA75",
            letterSpacing: "-0.02em",
          }}
        >
          Congratulations!
        </h1>

        <p
          style={{
            fontSize: "1.2rem",
            lineHeight: "1.6",
            marginBottom: "2rem",
            color: "#FFFFFF",
            fontWeight: "400",
          }}
        >
          You've claimed your $50 coupon with The Treatment. Mention code{" "}
          <strong style={{ color: "#CDAA75", fontWeight: "600" }}>
            AIFACE50
          </strong>{" "}
          at checkout to get an instant $50 off.
        </p>
      </div>
    </div>
  );
};

// Post-Consultation Survey
const AnalysisSummary = () => {
  useEffect(() => {
    window.location.href =
      "https://desert-olivine-d7e.notion.site/1913cb3b322380a2a28bcfe58ddb435d";
  }, []);

  return null;
};

// Joe Lapaglia Zcal Link for One-Pager
const JoeLapagliaZcal = () => {
  useEffect(() => {
    window.location.href =
      "https://zcal.co/i/lYMxcbQr/?a0=Joe%20LaPaglia&guests=jlapaglia@lasercap.com";
  }, []);

  return null;
};

// Nick Weisend Zcal Link for One-Pager
const NickWeisendZcal = () => {
  useEffect(() => {
    window.location.href =
      "https://zcal.co/i/lYMxcbQr/?a0=Nick%20Weisend&guests=nicholasweisend@gmail.com";
  }, []);

  return null;
};

// Leanne Land Zcal Link for One-Pager
const LeanneLandZcal = () => {
  useEffect(() => {
    window.location.href =
      "https://zcal.co/i/lYMxcbQr/?a0=Leanne%20Land&guests=merakiluxeaesthetics@gmail.com";
  }, []);

  return null;
};

// Leanne Land Zcal Link for One-Pager
const HerbRippleyZcal = () => {
  useEffect(() => {
    window.location.href =
      "https://zcal.co/i/lYMxcbQr/?a0=Herb%20Rippley&guests=hrippley@blueoceanmed.com";
  }, []);

  return null;
};

// Leanne Land Zcal Link for One-Pager
const JeffKlecatskyZcal = () => {
  useEffect(() => {
    window.location.href =
      "https://zcal.co/i/lYMxcbQr/?a0=Jeff%20Klecatsky&guests=Jeff@fortismedicaltech.com";
  }, []);

  return null;
};

// Leanne Land Zcal Link for One-Pager
const NatalieAlstonZcal = () => {
  useEffect(() => {
    window.location.href =
      "https://zcal.co/i/lYMxcbQr/?a0=Natalie%20Alston&guests=natalie.m.alston@gmail.com";
  }, []);

  return null;
};

// Leanne Land Zcal Link for One-Pager
const MattSnyderZcal = () => {
  useEffect(() => {
    window.location.href = "https://zcal.co/i/Usm057pQ";
  }, []);

  return null;
};

function App() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    localStorage.clear();
    if (location.search.length > 0) {
      const params = location.search.slice(1).split("&");
      const properties = ["provider", "channel", "subchannel"];
      params.forEach((item) => {
        const arr = item.split("=");
        const name = arr[0];
        if (properties.includes(name)) {
          localStorage.setItem(name, arr[1]);
        }
      });
    }
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, [location.search]);

  return (
    <div className="App">
      {loading ? (
        <SplashScreen />
      ) : (
        <Suspense fallback={<SplashScreen />}>
          <Routes>
            <Route path="/" element={<StartPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/otp" element={<Otp />} />
            <Route path="/upload" element={<Upload />} />
            <Route path="/success" element={<Success />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/now/*" element={<Now />} />
            <Route path="/face/*" element={<Face />} />
            <Route path="/web/*" element={<Web />} />
            <Route path="/qr/*" element={<QR />} />
            <Route path="/invite/*" element={<Invite />} />
            <Route path="/analysis-results" element={<RedirectToNotion />} />
            <Route path="/analysis-summary" element={<AnalysisSummary />} />
            <Route
              path="/treatment-claim-coupon"
              element={<TreatmentClaimCoupon />}
            />
            <Route path="/joelapaglia" element={<JoeLapagliaZcal />} />
            <Route path="/nickweisend" element={<NickWeisendZcal />} />
            <Route path="/leanneland" element={<LeanneLandZcal />} />
            <Route path="/herbrippley" element={<HerbRippleyZcal />} />
            <Route path="/jeffklecatsky" element={<JeffKlecatskyZcal />} />
            <Route path="/nataliealston" element={<NatalieAlstonZcal />} />
            <Route path="/mattsnyder" element={<MattSnyderZcal />} />
          </Routes>
        </Suspense>
      )}
    </div>
  );
}

export default App;
